export default __webpack_public_path__ + "static/media/Android-Screen.5744a32f.svg";